import { createAction, props } from '@ngrx/store';

export const setDebug = createAction(
  '[Debug] Set Debug',
  props<{ enabled: boolean }>(),
);
